module.exports = __webpack_public_path__ + "static/media/menu1.d537e6db.jpeg";